import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// Simple test to check Firestore connection
export const testFirestoreConnection = async (): Promise<boolean> => {
  try {
    // Test 1: Try to read from a simple collection first
    // Add a timeout to prevent hanging
    const readPromise = getDocs(collection(db, 'brands'));
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Connection timeout after 10 seconds')), 10000)
    );
    
    await Promise.race([readPromise, timeoutPromise]);
    
    // Test 2: Try to write a test document (only if read works)
    await addDoc(collection(db, 'connection_test'), {
      message: 'Connection test',
      timestamp: new Date(),
      testId: Math.random().toString(36).slice(2, 8)
    });
    
    return true;
    
  } catch (error) {
    console.error('❌ Firestore connection failed:', error);
    
    // Detailed error analysis
    if (error instanceof Error) {
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      
      if (error.message.includes('Missing or insufficient permissions')) {
        console.error('🔒 SOLUTION: This is a permissions issue. Check your Firestore security rules.');
        console.error('🔒 Make sure your rules allow authenticated users to read/write.');
      } else if (error.message.includes('not found') || error.message.includes('INVALID_ARGUMENT')) {
        console.error('🗄️ SOLUTION: Database configuration issue. Verify:');
        console.error('   1. Firestore is enabled in Firebase Console');
        console.error('   2. Database location matches (should be us-central1)');
        console.error('   3. Database ID is correct: rentaldb2');
        console.error('   4. Project ID is correct: car-rental-admin-2');
      } else if (error.message.includes('UNAUTHENTICATED')) {
        console.error('🔐 SOLUTION: User not authenticated. Make sure you\'re signed in.');
      } else if (error.message.includes('timeout')) {
        console.error('⏱️ SOLUTION: Connection timeout. This might be a network or configuration issue.');
      } else if (error.message.includes('Failed to get document')) {
        console.error('🌐 SOLUTION: Network connectivity issue or incorrect project configuration.');
      }
    }
    
    return false;
  }
};

// Test function that can be called from browser console
(window as any).testFirestore = testFirestoreConnection;
